export type AppLocale = 'de' | 'en' | 'fr' | 'es' | 'it';
export const SUPPORTED_LOCALES: AppLocale[] = ['de', 'en', 'fr', 'es', 'it'];

const STORAGE_KEY = 'rssign-locale';
const DACH_TIMEZONES = ['Europe/Berlin', 'Europe/Vienna', 'Europe/Zurich'];
const DACH_REGIONS = ['de', 'at', 'ch'];

function isSupported(value: string | null): value is AppLocale {
  return value != null && (SUPPORTED_LOCALES as string[]).includes(value);
}

export function detectDefaultLocale(): AppLocale {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (isSupported(saved)) {
    return saved;
  }

  const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const tag of languages) {
    const normalized = tag.toLowerCase();
    // DACH wins first (German default for de-*, and Austrian/Swiss/German regions).
    if (normalized.startsWith('de')) {
      return 'de';
    }
    const region = normalized.split('-')[1];
    if (region && DACH_REGIONS.includes(region)) {
      return 'de';
    }
    if (normalized.startsWith('fr')) return 'fr';
    if (normalized.startsWith('es')) return 'es';
    if (normalized.startsWith('it')) return 'it';
  }

  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (DACH_TIMEZONES.includes(timezone)) {
      return 'de';
    }
  } catch {
    // ignore
  }

  return 'en';
}

export function persistLocale(locale: AppLocale) {
  localStorage.setItem(STORAGE_KEY, locale);
}

export function getStoredLocale(): AppLocale | null {
  const saved = localStorage.getItem(STORAGE_KEY);
  return isSupported(saved) ? saved : null;
}
